import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, AfterViewInit, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UsersService } from '../services/users.service';
import { Location } from '@angular/common'
import { GlobalSearchService } from '../services/globalsearchservice.service';
import { PrintService } from '../services/print.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { MatSortModule, MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { FormControl } from '@angular/forms';

@Component({
	selector: 'app-users',
	templateUrl: './users.component.html',
	styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
	@ViewChild('userdetails') userDetails: ElementRef;
	@ViewChild(MatSort, { static: false }) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	title = 'users';
	users: any = [];
	allUsers: any = [];
	userSearch = new FormControl('')
	color = '';
	selecteduser: any = [];
	isSearching = false;
	filterdisabled = new FormControl(false);
	groupFilter = new FormControl(''); // default = all
	groupOptions: any[] = []; // populate from users



	yesno: any = [
		{ value: '0', name: 'No' },
		{ value: '1', name: 'Yes' }
	];
	headercolumns: string[];
	config: any;
	filename = 'users_list';
	exporting = false;

	constructor(private globalSearchService: GlobalSearchService, private route: ActivatedRoute, public router: Router, private userService: UsersService, private location: Location, private modalService: NgbModal, private printService: PrintService) {
		this.color = this.globalSearchService.getColor();
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		})
	}

	currentUserid: string = '';

	openUser(user) {
		this.selecteduser = user;
		this.modalService.open(this.userDetails, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {
		}, (reason) => {
			this.selecteduser = false;
		});
	}

	isCurrentUser(user: any): boolean {
		return !!this.currentUserid && (user.userid || '').toLowerCase() === this.currentUserid.toLowerCase();
	}

	disableUser(user: any) {
		if (this.isCurrentUser(user)) {
			this.globalSearchService.showNotification('You cannot disable your own account', 'warning', 'bottom', 'right');
			return;
		}
		if (!confirm(`Disable "${user.realname || user.userid}"? They will no longer be able to log in.`)) {
			return;
		}
		this.userService.updateUser(user.userid, { blocked: '1' }).subscribe({
			next: () => {
				this.globalSearchService.showNotification('User disabled', 'success', 'bottom', 'right');
				this.refreshUsers();
			},
			error: () => {
				this.globalSearchService.showNotification('Failed to disable user', 'danger', 'bottom', 'right');
			}
		});
	}

	enableUser(user: any) {
		this.userService.updateUser(user.userid, { blocked: '0' }).subscribe({
			next: () => {
				this.globalSearchService.showNotification('User re-enabled', 'success', 'bottom', 'right');
				this.refreshUsers();
			},
			error: () => {
				this.globalSearchService.showNotification('Failed to re-enable user', 'danger', 'bottom', 'right');
			}
		});
	}

	private refreshUsers() {
		this.userService.getUsers().subscribe((users: any) => {
			this.allUsers = users;
			this.groupOptions = Array.from(
				new Set(users.map((u: any) => u.groupname).filter((name: string) => !!name))
			).sort();
			const withSearch = this.globalSearchService.filterItem(
				this.allUsers,
				this.userSearch.value ?? '',
				'userid,realname,groupname'
			);
			this.setTableData(withSearch);
		});
	}

	updateUser(event: any) {
		this.modalService.dismissAll();
		this.refreshUsers();
	}

	ngOnInit(): void {
		const local = this.userService.getLocalUser();
		this.currentUserid = (local && local.user && local.user.userid) ? local.user.userid : '';

		if (this.config.env.package == 'beauty') {
			this.headercolumns = [
				'actions',
				'userid',
				'empcode',
				'realname',
				'groupname',
				'blocked',
				'viewcost'
			]
		} else {
			this.headercolumns = [
				'actions',
				'userid',
				'realname',
				'groupname',
				'blocked',
				'viewcost'
			]
		}

		this.userService.getUsers().subscribe((users: any) => {
			this.allUsers = users;
			this.groupOptions = Array.from(
				new Set(users.map((u: any) => u.groupname).filter(name => !!name))
			).sort();
			this.setTableData(users)
		})
	}

	ngOnDestroy(): void {

	}

	back(): void {
		this.location.back()
	}

	setTableData(users: any[]) {
		if (!this.filterdisabled.value) {
			users = users.filter((user: any) => user.blocked !== '1');
		}

		const selectedGroup = this.groupFilter.value;
		if (selectedGroup) {
			users = users.filter((user: any) => user.groupname === selectedGroup);
		}

		this.users = new MatTableDataSource(users);
		this.users.sort = this.sort;
		this.users.paginator = this.paginator;
		this.users.sortingDataAccessor = this.sortingDataAccessor;
	}


	sortingDataAccessor(data: any, sortHeaderID: string): string {
		return typeof data[sortHeaderID] === 'string'
			? data[sortHeaderID].toLowerCase()
			: data[sortHeaderID]
	}

	onInput() {
		const search = this.userSearch.value
		this.isSearching = true
		this.setTableData(this.globalSearchService.filterItem(this.allUsers, search, 'userid,realname,groupname'))
		this.isSearching = false
	}

	searchUsers() {
		this.onInput()
	}

	announceSortChange(event: any) {

	}

	exportPdf() {
		this.exporting = true;
		this.generateHtml().then((html) => {
			const encoded: string = this.globalSearchService.base64encode(html);
			const today = new Date();
			const data = {
				content: encoded,
				filename: this.filename,
				title: 'Users List',
				subtitle: 'Created ' + today.toLocaleString(),
				landscape: true
			};

			this.printService.pdf(data).subscribe((result: any) => {
				this.exporting = false;
				this.globalSearchService.downloadPdf(result.content, data.filename);
			});
		}).catch(() => {
			this.exporting = false;
		});
	}

	exportXls() {
		this.exporting = true;
		this.generateHtml().then((html) => {
			const encoded: string = this.globalSearchService.base64encode(html);
			const today = new Date();
			const data = {
				content: encoded,
				filename: this.filename,
				title: 'Users List',
				subtitle: 'Created ' + today.toLocaleString()
			};

			this.printService.xls(data).subscribe((result: any) => {
				this.exporting = false;
				this.globalSearchService.downloadXls(result.content, data.filename);
			});
		}).catch(() => {
			this.exporting = false;
		});
	}

	generateHtml(): Promise<string> {
		return new Promise((resolve) => {
			const rows = this.users && this.users.data ? this.users.data : [];
			let htmlParts: string[] = [];
			htmlParts.push('<div class="table">');
			htmlParts.push('<div class="bg-white mt-2 rounded">');
			htmlParts.push('<table class="table table-sm table-fixed collapsed">');
			htmlParts.push('<thead><tr>');
			htmlParts.push('<th>User ID</th>');
			if (this.config.env.package === 'beauty') {
				htmlParts.push('<th>Emp #</th>');
			}
			htmlParts.push('<th>Name</th>');
			htmlParts.push('<th>Role</th>');
			htmlParts.push('<th>Disabled</th>');
			htmlParts.push('<th>View Cost</th>');
			htmlParts.push('</tr></thead><tbody>');

			rows.forEach((u: any) => {
				htmlParts.push('<tr>');
				htmlParts.push(`<td>${u.userid || ''}</td>`);
				if (this.config.env.package === 'beauty') {
					htmlParts.push(`<td>${u.empcode || ''}</td>`);
				}
				htmlParts.push(`<td>${u.realname || ''}</td>`);
				htmlParts.push(`<td>${u.groupname || ''}</td>`);
				htmlParts.push(`<td>${u.blocked === '1' ? 'Yes' : 'No'}</td>`);
				htmlParts.push(`<td>${u.viewcost === '1' ? 'Yes' : 'No'}</td>`);
				htmlParts.push('</tr>');
			});

			htmlParts.push('</tbody></table></div></div>');
			resolve(htmlParts.join(''));
			htmlParts = null;
		});
	}

}
